import { ConsignmentSettlementListPage } from "@/features/consignment-settlement/pages/ConsignmentSettlementListPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/consignment-settlement/")({
	beforeLoad({ context }) {
		if (
			!context.authAdapter.can({ permissions: ["vendor_consignment.view"] })
		) {
			throw redirect({ to: "/403" });
		}
	},
	component: ConsignmentSettlementListPage,
});
